<template>
  <div class="like-buttons" :style="style" v-if="likes && Object.keys(likes).length > 1">
    <button type="button" class="btn btn-white btn-circle" @click.stop.prevent="clickLike">
      <SvgImage :src="likeImage" style="width:28px;height:28px;" />
    </button>
    <button type="button" class="btn btn-white btn-circle" @click.stop.prevent="clickDislike">
      <SvgImage :src="dislikeImage" style="width:28px;height:28px;" />
    </button>
  </div>
</template>
<script>
import {formSubmit} from '@/modules/configuration.js'
import SvgImage from "@/components/generic/SvgImage"
export default {
  components: {
    SvgImage
  },
  props: {
    likes: Object,
    position: {
      type: String,
      default: "top-left",
      validator: function (value) {
        return ['top-left', 'top-right','default'].includes(value)
      }
    }
  },
  data() {
    return {
      like_status: this.likes.like_status,
      dislike_status: this.likes.dislike_status
    }
  },
  computed: {
    style() {
      if (this.position == "top-left") {
        return "position:absolute; top: 15px; left: 20px;";
      }
      if (this.position == "top-right") {
        return "position:absolute; top: 15px; right: 20px;";
      }
      return "";
    },
    likeImage() {
      return this.likes.icons.like[this.like_status ? "selected" : "unselected"];
    },
    dislikeImage() {
      return this.likes.icons.dislike[this.dislike_status ? "selected" : "unselected"];
    }
  },
  methods: {
    async clickLike() {
      this.like_status = !this.like_status;
      this.dislike_status = false;
      const url = (this.like_status) ? this.likes.add_like_url : this.likes.remove_like_url;
      await formSubmit(this, null, url);
    },
    async clickDislike() {
      this.dislike_status = !this.dislike_status;
      this.like_status = false;
      const url = (this.dislike_status) ? this.likes.add_dislike_url : this.likes.remove_dislike_url;
      await formSubmit(this, null, url);
    }
  }
}
</script>
<style scoped>
.btn-white {
  background-color: white;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 15px;
}
</style>